export default __webpack_public_path__ + "static/media/ICT-Logo-V4-1-1 1 (1).9605f1d2.png";